import React from 'react';
import {HiOutlineCheckCircle} from '@react-icons/all-files/hi/HiOutlineCheckCircle';
import {HiOutlineUpload} from '@react-icons/all-files/hi/HiOutlineUpload';
import {HiOutlineXCircle} from '@react-icons/all-files/hi/HiOutlineXCircle';

export default function getUploadIconAndStatus(attachment = {}) {
    const {status} = attachment;

    switch (status) {
        case 'rejected':
            return {
                icon: <HiOutlineXCircle className="attachment-icon is-rejected" />,
                status: 'oss.components.WelcomePage.status.rejected'
            };
        case 'accepted':
        case 'in_progress':
            return {
                icon: <HiOutlineCheckCircle className="attachment-icon is-done" />,
                status: 'oss.components.WelcomePage.status.done'
            };
        case 'incomplete':
        case 'blocked':
        default:
            return {
                icon: <HiOutlineUpload className="attachment-icon" />,
                status: 'oss.components.WelcomePage.status.toDo'
            };
    }
}
